import { useTranslation } from 'react-i18next'
import { Text, Wizard } from '@lounge-fe/ui-kit'

export const Welcome = () => {
  const { t } = useTranslation()

  return (
    <Wizard.Step
      title="Welcome"
      className="flex flex-col gap-y-4 max-w-[420px] mx-auto"
    >
      <div>
        <Text
          as="h1"
          variant="title-three"
          className="md:typography--title-two text-center"
        >
          <Text
            as="span"
            variant="title-six"
            className="block normal-case md:typography--title-five text-center"
          >
            {t('fitting_room.welcome.title')}
          </Text>
          {t('fitting_room.welcome.subtitle')}
        </Text>
      </div>
      <Text className="text-center">{t('fitting_room.welcome.body')}</Text>
      <Wizard.Next className="w-full" size="lg">
        {t('fitting_room.welcome.action')}
      </Wizard.Next>
    </Wizard.Step>
  )
}
